import React from "react";
import '../css/default.css';
import '../css/salient.css';
import '../css/careHome.css';
import { getItem }        from '../Storage';
import { StringUtils, StyleUtils } from '../utils';
import { Loading }        from '../components';
import PetsController     from '../controllers/petsController';

export default class Profile extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      pets: [],
      loading_pets: false
    };
  }

  componentDidMount = async () => {
    this.setState({ loading_pets: true });
    let pets = await PetsController.getAllPets();
    this.setState({ pets: pets || [], loading_pets: false });
  }

  get_time_greeting = () => {
    let hour = new Date().getHours();
    if (hour < 12) { return 'Good morning'; }
    if (hour < 18) { return 'Good afternoon'; }
    return 'Good evening';
  }

  render_top_section = () => {
    let user           = getItem('user');
    let partner        = getItem('partner');
    let first_name     = user && user.first_name ? StringUtils.sentenceCase(user.first_name) : '';
    let is_embark      = partner && partner.name && partner.name.toLowerCase() === 'embark' ? true : false;
    let is_halo        = partner && partner.name && partner.name.toLowerCase() === 'halo'   ? true : false;
    let logo_url       = partner && partner.logo_url ? partner.logo_url : '';

    return <div className="carehome-hero-wrap">
      <div className="carehome-hero">
        <div className="carehome-hero-top">
          <div className="carehome-hero-logo-chip carehome-pressable"
               onClick={ () => { if (this.props.back_action) { this.props.back_action(); } } }>
            <img className="carehome-hero-logo" src={ logo_url } alt="" />
          </div>
          <div className="carehome-hero-avatar carehome-pressable"
               onClick={ () => { if (this.props.back_action) { this.props.back_action(); } } }>
            <span className='fas fa-home' style={{ fontSize: 16 }} />
          </div>
        </div>
        <div className="carehome-hero-greeting">
          <span className="carehome-hero-eyebrow">{ this.get_time_greeting() }</span>
          <span className="carehome-hero-welcome">{ first_name ? first_name : 'Welcome!' }</span>
          { !is_halo && <span className="carehome-hero-tagline">{ is_embark ? 'Training & behavior experts, all-in-one.' : 'Vet & behavior experts, all-in-one.' }</span> }
        </div>
      </div>
    </div>
  }

  render_info_row = (label, value) => {
    if (!value) { return null }

    return <div className="carehome-row" key={label}>
      <div className="carehome-row-main">
        <span className="carehome-row-sub">{ label }</span>
        <span className="carehome-row-title">{ value }</span>
      </div>
    </div>
  }

  render_user_section = () => {
    let user       = getItem('user');
    let first_name = user && user.first_name ? StringUtils.sentenceCase(user.first_name) : '';
    let last_name  = user && user.last_name  ? StringUtils.sentenceCase(user.last_name)  : '';
    let email      = user && user.email ? user.email : '';
        email      = !email && user && user.contact && user.contact.email ? user.contact.email : email;
    let partner    = getItem('partner');
    let hide_phone = partner && partner.hide_phone_number === true;
    let phone      = !hide_phone && user && user.phone_number ? StringUtils.displayCodePhoneNumber(user.phone_number) : '';

    return <div className="carehome-section">
      <span className="carehome-section-label">Your Info</span>
      <div className="carehome-list">
        { this.render_info_row('First Name', first_name) }
        { this.render_info_row('Last Name', last_name) }
        { this.render_info_row('Email', email) }
        { this.render_info_row('Phone', phone) }
      </div>
    </div>
  }

  render_pet_box = (pet) => {
    let name      = StringUtils.displayName(pet);
    let type_str  = pet && pet.type ? StringUtils.sentenceCase(pet.type) : '';
    let gender    = StringUtils.displayGender(pet.gender) || '';
    let partner   = getItem('partner');
    let hide_dob  = partner && partner.hide_pet_dob === true;
    let birthday  = !hide_dob && pet && pet.birthday ? pet.birthday : '';
    let weight    = pet && pet.weight ? pet.weight + ' lbs' : '';
    let fixed     = pet && (pet.spayed === true || pet.neutered === true) ? 'Spayed / Neutered' : '';

    let breed     = pet && pet.breed && pet.breed.toLowerCase() !== 'unknown' ? StringUtils.sentenceCase(pet.breed) : '';
    let photo_url = pet && pet.photo_url ? pet.photo_url : '';

    let details = [type_str, breed, gender, birthday, weight, fixed].filter((detail) => { return detail });

    return <div className="carehome-row" key={pet._id}>
      { photo_url ? <div className="carehome-row-icon" style={{ overflow: 'hidden' }}>
          <img src={photo_url} alt={name} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
        </div> : null }
      <div className="carehome-row-main" style={ photo_url ? {} : { marginLeft: 0 } }>
        <span className="carehome-row-title">{ name }</span>
        <span className="carehome-row-sub">{ details.join('  ·  ') }</span>
      </div>
    </div>
  }

  render_pets_section = () => {
    if (this.state.loading_pets) {
      return <div className="carehome-section">
        <span className="carehome-section-label">Your Pets</span>
        <Loading type='bored_cat' title='Loading Pets...' />
      </div>
    }

    let pets = this.state.pets || [];
    if (pets.length === 0) { return null }

    let pet_rows = pets.map((pet) => {
      return this.render_pet_box(pet);
    });

    return <div className="carehome-section">
      <span className="carehome-section-label">Your Pets</span>
      <div className="carehome-list">
        { pet_rows }
      </div>
    </div>
  }

  render() {
    let root_style = {
      '--ch-accent':      StyleUtils.get_header_color(),
      '--ch-grad-start':  StyleUtils.get_header_gradient_start(),
      '--ch-grad-end':    StyleUtils.get_header_gradient_end(),
      '--ch-accent-text': StyleUtils.get_header_text_color_auto(),
      '--ch-button':      StyleUtils.get_button_color(),
      '--ch-button-text': StyleUtils.get_button_text_color_auto(),
      '--ch-primary':     StyleUtils.get_primary_color(),
    };

    return <div className="carehome-root" style={root_style}>
      { this.render_top_section() }

      <div className="carehome-content">
        { this.render_user_section() }
        { this.render_pets_section() }
      </div>

      <div style={{ height: 80 }} />
    </div>
  }
}
